export var KeyEvent;
(function (KeyEvent) {
    KeyEvent["KEYDOWN"] = "keydown";
    KeyEvent["KEYPRESS"] = "keypress";
    KeyEvent["KEYUP"] = "keyup";
})(KeyEvent || (KeyEvent = {}));
